<template>
  <div class="d-flex justify-content-center align-items-stretc flex-grow-1 w-100">
  <object :data="url" type="application/pdf" class="flex-grow-0 mt-1" style="min-width: 65em">
    <embed :src="url" type="application/pdf"/>
  </object>
  </div>
</template>

<script>
  export default {
    data: () => {
      return {
        url: '/agreement.pdf#toolbar=0&navpanes=0&scrollbar=0&statusbar=0&messages=0&scrollbar=0',
      }
    },
  }
</script>



// WEBPACK FOOTER //
// resources/assets/js/pages/admin/info/agreement.vue